import {Box} from 'grommet'
import { useEffect, useState } from 'react'

import {VerificationStatus, useStatus} from '../../api/status'
import CenteredMain from '../../components/layout/CenteredMain'
import Page from '../../components/layout/Page'
import ApiError from '../../components/status/ApiError'
import Error from '../../components/status/Error'
import InProgress from '../../components/status/InProgress'
import Verified from '../../components/status/Verified'
import LoadingSpinner from '../../components/ui/LoadingSpinner'
import { useGoToPage } from '../../routeConfig'

const baseRefetchInterval = 5000

function Status() {
  const [refetchInterval, setRefetchInterval] = useState<number | undefined>(baseRefetchInterval)
  const {data, isLoading, isError} = useStatus(refetchInterval)
  const goToPage = useGoToPage()

  useEffect(() => {
    if (data?.status === VerificationStatus.missingInformation) {
      // Go to the user info page if there's missing information
      goToPage('additional-information')
    } if (data?.status !== VerificationStatus.inProgress) {
      // Stop checking the status if it's not in progress - we just need to show the message
      setRefetchInterval(undefined)
    }
  }, [data?.status, goToPage])

  return (
    <Page titleTranslation="page.status.title">
      <CenteredMain>
        <Box>
          {isError && <ApiError />}
          {!data?.status && isLoading && <LoadingSpinner />}
          {data?.status === VerificationStatus.inProgress && <InProgress />}
          {data?.status === VerificationStatus.verified && <Verified />}
          {data?.status === VerificationStatus.error && <Error />}
        </Box>
      </CenteredMain>
    </Page>
  )
}

export default Status
